import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/brand/Logo";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin/inventario" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/admin/inventario", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "Credenciales inválidas"));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col bg-white text-[#3E5641]" data-testid="page-admin-login">
      <header className="border-b border-[#3E5641]/10">
        <div className="container-x flex h-16 items-center justify-between">
          <Logo />
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#6B7678] hover:text-[#3E5641]" data-testid="admin-back-home">
            <ArrowLeft size={14} /> Volver al sitio
          </Link>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-6 py-12">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-sm border border-[#3E5641]/10 bg-white p-8"
          data-testid="admin-login-form"
        >
          <p className="mono text-xs uppercase tracking-widest text-[#A0553F]">Panel interno</p>
          <h1 className="mt-2 font-serif text-3xl text-[#3E5641]">Iniciar sesión</h1>
          <p className="mt-2 text-sm text-[#6B7678]">Solo personal autorizado de La Dupla Automotriz.</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label className="field-label">Correo</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label className="field-label">Contraseña</Label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                data-testid="admin-login-password"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="btn-primary w-full disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {submitting ? "Entrando..." : "Entrar"}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}
